import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

export interface UpdateDiskDTO {
  size?: number;
}

export const patchDisk = async (client: Client, id: string, disk: UpdateDiskDTO) => {
  return await client(endpoint.patchMyDisk(id), "PATCH", disk);
};

export const useUpdateDisk = () => {
  const toastError = useErrorToaster();
  const { mutate } = useSWRConfig();

  return async (diskId: string, size: number): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await patchDisk(client, diskId, { size: size });

      mutate(endpoint.getMyDisks);
      mutate(endpoint.getMyDisk(diskId));

      toast.success(`Disk updated: ${diskId}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError(`Failed to update disk: ${diskId}`, error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);

        return error.response;
      }
    }

    return response;
  };
};
